<div class="footer-layout">
    @for (pageCommand of visiblePageCommands() ?? []; track pageCommand.name) {
        @if (pageCommand.type === PageCommandType.Primary) {
            <app-button [disabled]="pageCommand.disabled" primary width="100%" (buttonClick)="pageCommand.action()">{{pageCommand.text}}</app-button>
        }
        @else if (pageCommand.type === PageCommandType.Secondary) {
            <app-button [disabled]="pageCommand.disabled" secondary width="100%" (buttonClick)="pageCommand.action()">{{pageCommand.text}}</app-button>
        }
        @else {
            <app-button [disabled]="pageCommand.disabled" tertiery width="100%" (buttonClick)="pageCommand.action()">{{pageCommand.text}}</app-button>
        }
    }
</div>
